// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v2/user.proto

/* oxlint-disable */

/** Enum for gender. */
export const ApiGender = {
  /** GENDER_UNSPECIFIED - Unspecified gender. */
  GENDER_UNSPECIFIED: "GENDER_UNSPECIFIED",
  /**
   * male - Male gender.
   */
  male: "male",
  /**
   * female - Female gender.
   */
  female: "female",
  /**
   * other - Other gender.
   */
  other: "other",
} as const;

export type ApiGender = typeof ApiGender[keyof typeof ApiGender];

export namespace ApiGender {
  export type GENDER_UNSPECIFIED = typeof ApiGender.GENDER_UNSPECIFIED;
  export type male = typeof ApiGender.male;
  export type female = typeof ApiGender.female;
  export type other = typeof ApiGender.other;
}

export function apiGenderFromJSON(object: any): ApiGender {
  switch (object) {
    case 0:
    case "GENDER_UNSPECIFIED":
      return ApiGender.GENDER_UNSPECIFIED;
    case 1:
    case "male":
      return ApiGender.male;
    case 2:
    case "female":
      return ApiGender.female;
    case 3:
    case "other":
      return ApiGender.other;
    default:
      return ApiGender.GENDER_UNSPECIFIED;
  }
}

export function apiGenderToJSON(object: ApiGender): string {
  switch (object) {
    case ApiGender.GENDER_UNSPECIFIED:
      return "GENDER_UNSPECIFIED";
    case ApiGender.male:
      return "male";
    case ApiGender.female:
      return "female";
    case ApiGender.other:
      return "other";
    default:
      return "GENDER_UNSPECIFIED";
  }
}

/** Enum for authentication methods (used by both OTP and MFA). */
export const ApiAuthMethod = {
  /** AUTH_METHOD_UNSPECIFIED - Unspecified authentication method. */
  AUTH_METHOD_UNSPECIFIED: "AUTH_METHOD_UNSPECIFIED",
  /**
   * by_sms - Authentication by SMS.
   */
  by_sms: "by_sms",
  /**
   * by_app - Authentication by app.
   */
  by_app: "by_app",
} as const;

export type ApiAuthMethod = typeof ApiAuthMethod[keyof typeof ApiAuthMethod];

export namespace ApiAuthMethod {
  export type AUTH_METHOD_UNSPECIFIED = typeof ApiAuthMethod.AUTH_METHOD_UNSPECIFIED;
  export type by_sms = typeof ApiAuthMethod.by_sms;
  export type by_app = typeof ApiAuthMethod.by_app;
}

export function apiAuthMethodFromJSON(object: any): ApiAuthMethod {
  switch (object) {
    case 0:
    case "AUTH_METHOD_UNSPECIFIED":
      return ApiAuthMethod.AUTH_METHOD_UNSPECIFIED;
    case 1:
    case "by_sms":
      return ApiAuthMethod.by_sms;
    case 2:
    case "by_app":
      return ApiAuthMethod.by_app;
    default:
      return ApiAuthMethod.AUTH_METHOD_UNSPECIFIED;
  }
}

export function apiAuthMethodToJSON(object: ApiAuthMethod): string {
  switch (object) {
    case ApiAuthMethod.AUTH_METHOD_UNSPECIFIED:
      return "AUTH_METHOD_UNSPECIFIED";
    case ApiAuthMethod.by_sms:
      return "by_sms";
    case ApiAuthMethod.by_app:
      return "by_app";
    default:
      return "AUTH_METHOD_UNSPECIFIED";
  }
}

/** Message for avatar/image objects. */
export interface ApiAvatar {
  /** The URL of the file. */
  readonly fileUrl: string;
}

/** Message for user flags. */
export interface ApiUserFlags {
  /** Whether the user has a password set. */
  readonly hasPassword: boolean;
  /**
   * Severity level of credential exposure detected for the user, if any.
   * 0 = not compromised or out of scope (default/absent).
   * 1 = both email and password leaked.
   * 2 = password only leaked.
   */
  readonly credentialExposureLevel?: number | null | undefined;
}

/** Message for Zendesk integration data. */
export interface ApiZendesk {
  /** JWT token for messaging widget. */
  readonly messagingWidgetJwt: string;
  /** JWT token for SSO. */
  readonly ssoJwt: string;
}

/** Message for the user. */
export interface ApiUser {
  /** Unique identifier for the user. */
  readonly id: string;
  /** Email address of the user. */
  readonly email: string;
  /** Segment identifier for analytics. */
  readonly segmentId: string;
  /** Phone number of the user. */
  readonly phoneNumber?:
    | string
    | null
    | undefined;
  /** Full name of the user. */
  readonly fullName: string;
  /** First name of the user. */
  readonly firstName: string;
  /** Last name of the user. */
  readonly lastName: string;
  /** Gender of the user. */
  readonly gender?:
    | ApiGender
    | null
    | undefined;
  /** Locale preference of the user. */
  readonly locale: string;
  /** Timezone of the user. */
  readonly timezone: string;
  /** Birth date of the user (YYYY-MM-DD format). */
  readonly birthdate?:
    | string
    | null
    | undefined;
  /** Birth city of the user. */
  readonly birthCity?:
    | string
    | null
    | undefined;
  /** Birth zipcode of the user. */
  readonly birthZipcode?:
    | string
    | null
    | undefined;
  /** Birth country of the user. */
  readonly birthCountry?:
    | string
    | null
    | undefined;
  /** Whether the user has completed onboarding. */
  readonly onboarded: boolean;
  /** Whether the user has a default avatar. */
  readonly hasDefaultAvatar: boolean;
  /** Avatar thumbnail of the user. */
  readonly avatarThumb?:
    | ApiAvatar
    | null
    | undefined;
  /** Avatar of the user. */
  readonly avatar?:
    | ApiAvatar
    | null
    | undefined;
  /** Default avatar thumbnail of the user. */
  readonly defaultAvatarThumb?:
    | ApiAvatar
    | null
    | undefined;
  /** Default avatar of the user. */
  readonly defaultAvatar?:
    | ApiAvatar
    | null
    | undefined;
  /** Pending email change. */
  readonly pendingEmail?:
    | string
    | null
    | undefined;
  /** Pending phone number change. */
  readonly pendingPhoneNumber?:
    | string
    | null
    | undefined;
  /** Whether the phone number is verified. */
  readonly phoneNumberVerified: boolean;
  /** Whether OTP is enabled. */
  readonly otpEnabled: boolean;
  /** OTP method preference. */
  readonly otpMethod?:
    | ApiAuthMethod
    | null
    | undefined;
  /** Whether MFA is enabled. */
  readonly mfaEnabled: boolean;
  /** MFA method preference. */
  readonly mfaMethod?:
    | ApiAuthMethod
    | null
    | undefined;
  /** Futurae user identifier. */
  readonly futuraeUserId?:
    | string
    | null
    | undefined;
  /** Whether SCA enrollment is available. */
  readonly scaEnrollmentAvailable: boolean;
  /** Whether the user can enroll trusted device using SMS OTP. */
  readonly canEnrollTrustedDeviceUsingSmsOtp: boolean;
  /** Whether SCA is enabled. */
  readonly scaEnabled: boolean;
  /** Whether tougher SCA approach is enabled. */
  readonly tougherScaApproachEnabled: boolean;
  /** User flags containing additional boolean settings. */
  readonly flags:
    | ApiUserFlags
    | null;
  /** Zendesk integration data. */
  readonly zendesk: ApiZendesk | null;
}

export const ApiAvatar: MessageFns<ApiAvatar> = {
  fromJSON(object: any): ApiAvatar {
    return { fileUrl: isSet(object.file_url) ? globalThis.String(object.file_url) : "" };
  },

  toJSON(message: ApiAvatar): unknown {
    const obj: any = {};
    if (message.fileUrl !== undefined && message.fileUrl !== null) {
      obj.file_url = message.fileUrl;
    }
    return obj;
  },
};

export const ApiUserFlags: MessageFns<ApiUserFlags> = {
  fromJSON(object: any): ApiUserFlags {
    return {
      hasPassword: isSet(object.has_password) ? globalThis.Boolean(object.has_password) : false,
      credentialExposureLevel: isSet(object.credential_exposure_level)
        ? globalThis.Number(object.credential_exposure_level)
        : null,
    };
  },

  toJSON(message: ApiUserFlags): unknown {
    const obj: any = {};
    if (message.hasPassword !== undefined && message.hasPassword !== null) {
      obj.has_password = message.hasPassword;
    }
    if (message.credentialExposureLevel !== undefined && message.credentialExposureLevel !== null) {
      obj.credential_exposure_level = Math.round(message.credentialExposureLevel);
    }
    return obj;
  },
};

export const ApiZendesk: MessageFns<ApiZendesk> = {
  fromJSON(object: any): ApiZendesk {
    return {
      messagingWidgetJwt: isSet(object.messaging_widget_jwt) ? globalThis.String(object.messaging_widget_jwt) : "",
      ssoJwt: isSet(object.sso_jwt) ? globalThis.String(object.sso_jwt) : "",
    };
  },

  toJSON(message: ApiZendesk): unknown {
    const obj: any = {};
    if (message.messagingWidgetJwt !== undefined && message.messagingWidgetJwt !== null) {
      obj.messaging_widget_jwt = message.messagingWidgetJwt;
    }
    if (message.ssoJwt !== undefined && message.ssoJwt !== null) {
      obj.sso_jwt = message.ssoJwt;
    }
    return obj;
  },
};

export const ApiUser: MessageFns<ApiUser> = {
  fromJSON(object: any): ApiUser {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      segmentId: isSet(object.segment_id) ? globalThis.String(object.segment_id) : "",
      phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : null,
      fullName: isSet(object.full_name) ? globalThis.String(object.full_name) : "",
      firstName: isSet(object.first_name) ? globalThis.String(object.first_name) : "",
      lastName: isSet(object.last_name) ? globalThis.String(object.last_name) : "",
      gender: isSet(object.gender) ? apiGenderFromJSON(object.gender) : null,
      locale: isSet(object.locale) ? globalThis.String(object.locale) : "",
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
      birthdate: isSet(object.birthdate) ? globalThis.String(object.birthdate) : null,
      birthCity: isSet(object.birth_city) ? globalThis.String(object.birth_city) : null,
      birthZipcode: isSet(object.birth_zipcode) ? globalThis.String(object.birth_zipcode) : null,
      birthCountry: isSet(object.birth_country) ? globalThis.String(object.birth_country) : null,
      onboarded: isSet(object.onboarded) ? globalThis.Boolean(object.onboarded) : false,
      hasDefaultAvatar: isSet(object.has_default_avatar) ? globalThis.Boolean(object.has_default_avatar) : false,
      avatarThumb: isSet(object.avatar_thumb) ? ApiAvatar.fromJSON(object.avatar_thumb) : null,
      avatar: isSet(object.avatar) ? ApiAvatar.fromJSON(object.avatar) : null,
      defaultAvatarThumb: isSet(object.default_avatar_thumb) ? ApiAvatar.fromJSON(object.default_avatar_thumb) : null,
      defaultAvatar: isSet(object.default_avatar) ? ApiAvatar.fromJSON(object.default_avatar) : null,
      pendingEmail: isSet(object.pending_email) ? globalThis.String(object.pending_email) : null,
      pendingPhoneNumber: isSet(object.pending_phone_number) ? globalThis.String(object.pending_phone_number) : null,
      phoneNumberVerified: isSet(object.phone_number_verified)
        ? globalThis.Boolean(object.phone_number_verified)
        : false,
      otpEnabled: isSet(object.otp_enabled) ? globalThis.Boolean(object.otp_enabled) : false,
      otpMethod: isSet(object.otp_method) ? apiAuthMethodFromJSON(object.otp_method) : null,
      mfaEnabled: isSet(object.mfa_enabled) ? globalThis.Boolean(object.mfa_enabled) : false,
      mfaMethod: isSet(object.mfa_method) ? apiAuthMethodFromJSON(object.mfa_method) : null,
      futuraeUserId: isSet(object.futurae_user_id) ? globalThis.String(object.futurae_user_id) : null,
      scaEnrollmentAvailable: isSet(object.sca_enrollment_available)
        ? globalThis.Boolean(object.sca_enrollment_available)
        : false,
      canEnrollTrustedDeviceUsingSmsOtp: isSet(object.can_enroll_trusted_device_using_sms_otp)
        ? globalThis.Boolean(object.can_enroll_trusted_device_using_sms_otp)
        : false,
      scaEnabled: isSet(object.sca_enabled) ? globalThis.Boolean(object.sca_enabled) : false,
      tougherScaApproachEnabled: isSet(object.tougher_sca_approach_enabled)
        ? globalThis.Boolean(object.tougher_sca_approach_enabled)
        : false,
      flags: isSet(object.flags) ? ApiUserFlags.fromJSON(object.flags) : null,
      zendesk: isSet(object.zendesk) ? ApiZendesk.fromJSON(object.zendesk) : null,
    };
  },

  toJSON(message: ApiUser): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    if (message.segmentId !== undefined && message.segmentId !== null) {
      obj.segment_id = message.segmentId;
    }
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    if (message.fullName !== undefined && message.fullName !== null) {
      obj.full_name = message.fullName;
    }
    if (message.firstName !== undefined && message.firstName !== null) {
      obj.first_name = message.firstName;
    }
    if (message.lastName !== undefined && message.lastName !== null) {
      obj.last_name = message.lastName;
    }
    if (message.gender !== undefined && message.gender !== null) {
      obj.gender = apiGenderToJSON(message.gender);
    }
    if (message.locale !== undefined && message.locale !== null) {
      obj.locale = message.locale;
    }
    if (message.timezone !== undefined && message.timezone !== null) {
      obj.timezone = message.timezone;
    }
    if (message.birthdate !== undefined && message.birthdate !== null) {
      obj.birthdate = message.birthdate;
    }
    if (message.birthCity !== undefined && message.birthCity !== null) {
      obj.birth_city = message.birthCity;
    }
    if (message.birthZipcode !== undefined && message.birthZipcode !== null) {
      obj.birth_zipcode = message.birthZipcode;
    }
    if (message.birthCountry !== undefined && message.birthCountry !== null) {
      obj.birth_country = message.birthCountry;
    }
    if (message.onboarded !== undefined && message.onboarded !== null) {
      obj.onboarded = message.onboarded;
    }
    if (message.hasDefaultAvatar !== undefined && message.hasDefaultAvatar !== null) {
      obj.has_default_avatar = message.hasDefaultAvatar;
    }
    if (message.avatarThumb !== undefined && message.avatarThumb !== null) {
      obj.avatar_thumb = ApiAvatar.toJSON(message.avatarThumb);
    }
    if (message.avatar !== undefined && message.avatar !== null) {
      obj.avatar = ApiAvatar.toJSON(message.avatar);
    }
    if (message.defaultAvatarThumb !== undefined && message.defaultAvatarThumb !== null) {
      obj.default_avatar_thumb = ApiAvatar.toJSON(message.defaultAvatarThumb);
    }
    if (message.defaultAvatar !== undefined && message.defaultAvatar !== null) {
      obj.default_avatar = ApiAvatar.toJSON(message.defaultAvatar);
    }
    if (message.pendingEmail !== undefined && message.pendingEmail !== null) {
      obj.pending_email = message.pendingEmail;
    }
    if (message.pendingPhoneNumber !== undefined && message.pendingPhoneNumber !== null) {
      obj.pending_phone_number = message.pendingPhoneNumber;
    }
    if (message.phoneNumberVerified !== undefined && message.phoneNumberVerified !== null) {
      obj.phone_number_verified = message.phoneNumberVerified;
    }
    if (message.otpEnabled !== undefined && message.otpEnabled !== null) {
      obj.otp_enabled = message.otpEnabled;
    }
    if (message.otpMethod !== undefined && message.otpMethod !== null) {
      obj.otp_method = apiAuthMethodToJSON(message.otpMethod);
    }
    if (message.mfaEnabled !== undefined && message.mfaEnabled !== null) {
      obj.mfa_enabled = message.mfaEnabled;
    }
    if (message.mfaMethod !== undefined && message.mfaMethod !== null) {
      obj.mfa_method = apiAuthMethodToJSON(message.mfaMethod);
    }
    if (message.futuraeUserId !== undefined && message.futuraeUserId !== null) {
      obj.futurae_user_id = message.futuraeUserId;
    }
    if (message.scaEnrollmentAvailable !== undefined && message.scaEnrollmentAvailable !== null) {
      obj.sca_enrollment_available = message.scaEnrollmentAvailable;
    }
    if (message.canEnrollTrustedDeviceUsingSmsOtp !== undefined && message.canEnrollTrustedDeviceUsingSmsOtp !== null) {
      obj.can_enroll_trusted_device_using_sms_otp = message.canEnrollTrustedDeviceUsingSmsOtp;
    }
    if (message.scaEnabled !== undefined && message.scaEnabled !== null) {
      obj.sca_enabled = message.scaEnabled;
    }
    if (message.tougherScaApproachEnabled !== undefined && message.tougherScaApproachEnabled !== null) {
      obj.tougher_sca_approach_enabled = message.tougherScaApproachEnabled;
    }
    if (message.flags !== undefined && message.flags !== null) {
      obj.flags = ApiUserFlags.toJSON(message.flags);
    }
    if (message.zendesk !== undefined && message.zendesk !== null) {
      obj.zendesk = ApiZendesk.toJSON(message.zendesk);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
